<template>
  <div ref="checkout">
    <section v-if="windowSize >= 576" class="pt-0 delivery-checkout">
      <div class="container">
        <payment></payment>
      </div>
    </section>
    <mobile-cart v-else></mobile-cart>
  </div>
</template>

<script>
import Payment from '../Blocks/Payment'
import { mapGetters } from 'vuex'
//import { Item } from '@/helpers/Item'
import Windowsize from '@/mixins/Windowsize'
import Delivery from '@/mixins/Delivery'
import MobileCart from '@/components/Blocks/Cart/MobileCart.vue'

export default {
  mixins: [Windowsize, Delivery],
  name: 'Cart',
  components: { Payment, MobileCart },
  computed: {
    ...mapGetters([
      'customer_addresses',
      'customer_addresses_by_store_id',
      'cart_items_count',
      'brandStoreRoute',
      'brandStoreParams',
      'selected_order',
      'customerPosition',
    ]),
  },
  mounted() {
    const process = 'simplify_load'
    this.$store.dispatch('startProcess', { process, progress: false })
    let script = document.createElement('script')
    script.onload = () => {
      this.$store.dispatch('stopProcess', process)
    }
    script.async = true
    script.src = 'https://www.simplify.com/commerce/v1/simplify.js'
    document.head.appendChild(script)

    let storeId = this.$route.params.store_id
    var cust_addresses_by_store_id = this.customer_addresses
      ? this.customer_addresses_by_store_id(storeId)
      : []
    if (cust_addresses_by_store_id.length > 0) {
      var addr_to_select = cust_addresses_by_store_id[0]
      // for (var addr of cust_addresses_by_store_id) {
      //   if (
      //     addr.location_coordinates.lat ==
      //       this.customerPosition.coordinates.lat &&
      //     addr.location_coordinates.lng == this.customerPosition.coordinates.lng
      //   ) {
      //     addr_to_select = addr
      //   }
      // }
      this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', addr_to_select)
    }

    if (!this.cart_items_count) {
      this.$router.replace({
        name: this.brandStoreRoute('store_page'),
        params: {
          ...this.brandStoreParams,
        },
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .delivery-checkout {
    &::before {
      left: 0;
      right: unset;
    }
  }
}
.delivery-checkout {
  position: relative;
  &::before {
    position: absolute;
    content: '';
    background-color: $light-sky;
    right: 0;
    width: $px470;
    height: 100%;
    z-index: -1;
  }
}
@media (max-width: 1199px) {
  .delivery-checkout {
    &::before {
      width: $px300;
    }
  }
}
@media (max-width: 991px) {
  .delivery-checkout {
    &::before {
      display: none;
    }
  }
}
@media (max-width: 575px) {
  .delivery-checkout {
    display: none;
  }
}
</style>
